export default __webpack_public_path__ + "static/media/Customization Tools.b30b506b.svg";